/**
 * Labstep
 *
 * @module components/Log/Filter/ObjectClass
 * @desc Log Object Class filter
 */

import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { Select as ReactSelect } from 'labstep-web/core/Select';
import type { ReactSelectOption } from 'labstep-web/core/Select/types';
import { LogObjectClassLabels } from 'labstep-web/models/log.model';
import type React from 'react';
import type { LogFilterObjectClassProps } from './types';

export const LogFilterObjectClass: React.FC<
  LogFilterObjectClassProps
> = ({ setParams, searchParams, actionComponentProps }) => (
  <Modal
    header={'Entity Type'}
    content={({ toggleModal }) => (
      <ReactSelect
        defaultValue={
          searchParams.object_class
            ? {
                value: searchParams.object_class,
                label:
                  LogObjectClassLabels[
                    searchParams.object_class as keyof typeof LogObjectClassLabels
                  ],
              }
            : null
        }
        options={Object.keys(LogObjectClassLabels).map((key) => ({
          value: key,
          label:
            LogObjectClassLabels[
              key as keyof typeof LogObjectClassLabels
            ],
        }))}
        isClearable
        onChange={(selectedOption: ReactSelectOption) => {
          const value = selectedOption
            ? selectedOption.value
            : undefined;
          if (setParams) {
            setParams({
              object_class: value,
            });
          }
          toggleModal();
        }}
        placeholder="Select entity type"
      />
    )}
    viewComponent={({ toggleModal }) => (
      <ActionComponent
        type="option"
        icon={ICONS.log.object_class}
        text="Entity Type"
        onClick={toggleModal}
        {...actionComponentProps}
      />
    )}
  />
);
